export default {
    BASE_URL: process.env.SOURCE_API,
    ARCHIVE_URL: process.env.SOURCE_ARCHIVES
};